export const ROLE_ADMIN = 1
export const ROLE_USER = 2

export const SOURCE_TYPE_SYSTEM_GENERATE = 0
export const SOURCE_TYPE_REGISTER = 1
export const SOURCE_TYPE_ADMIN_ADD = 2
export const roleList = [
  {
    label: '普通用户',
    value: ROLE_USER,
  },
  {
    label: '管理员',
    value: ROLE_ADMIN,
  },
]

export const sourceList = [
  {
    label: '系统生成',
    value: SOURCE_TYPE_SYSTEM_GENERATE,
  },
  {
    label: '注册',
    value: SOURCE_TYPE_REGISTER,
  },
  {
    label: '管理员添加',
    value: SOURCE_TYPE_ADMIN_ADD,
  },
]
